<form
  name="form"
  autocomplete="off"
  class="tab-groups field-dialog__content__scroll"
  [class.with-disclaimer]="isViewMode"
  fusePerfectScrollbar
>
  <disclaimer *ngIf="isViewMode" [message]="'LOCATIONS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
  <disclaimer *ngIf="!isViewMode" [message]="'LOCATIONS.DIALOG.TABS.TAB_GROUP.DISCLAIMER' | translate"> </disclaimer>

  <div class="field-outline-form">
    <div class="search-bar">
      <mat-form-field class="search-bar__input" appearance="outline">
        <mat-label> {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINKED.SEARCH' | translate }}</mat-label>
        <mat-icon matPrefix color="primary">search</mat-icon>
        <input matInput [formControl]="searchInput" (keydown)="$event.stopImmediatePropagation()" />
        <mat-hint> {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.SEARCH_SUGGESTION' | translate }}</mat-hint>
      </mat-form-field>

      <button
        class="search-bar__button"
        color="primary"
        mat-raised-button
        *ngIf="!isViewMode"
        (click)="openLinkGroupDialog()"
      >
        {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINKED.ADD' | translate }}
      </button>
    </div>
  </div>

  <div class="tab-groups__title-wrapper">
    <p class="tab-groups__title-text">
      {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINKED.TITLE' | translate }} ({{ page?.totalCount || 0 }})
    </p>
  </div>

  <ng-container *ngIf="isLoading; else pageTemplate">
    <div class="loading">
      <mat-spinner class="loading__spinner" diameter="64"></mat-spinner>
      <span class="loading__text"> {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LOADING' | translate }}</span>
    </div>
  </ng-container>

  <ng-template #pageTemplate>
    <div class="card-list">
      <ng-container *ngIf="page?.items.length; else noGroups">
        <div class="card-list__item" *ngFor="let group of page.items">
          <div class="card-list__item-content">
            <p class="card-list__item-title">
              {{ group.name }}
              <span class="card-list__archived-item" *ngIf="group.archived">
                {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINKED.ARCHIVED' | translate }}
              </span>
            </p>
            <p class="card-list__item-description">{{ group.description }}</p>
          </div>

          <div class="card-list__item-control" *ngIf="!isViewMode">
            <p *ngIf="group.type === 'owner'">
              {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINKED.DEFAULT' | translate }}
            </p>
            <mat-spinner *ngIf="group['isSaving']" color="primary" diameter="20"></mat-spinner>
            <button
              mat-icon-button
              *ngIf="!group['isSaving'] && group.type !== 'owner'"
              [matTooltip]="'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINKED.UNLINK' | translate"
              (click)="removeSegmentFroGroup(group)"
            >
              <i class="angularjs-fuse-icon icon-delete"></i>
            </button>
          </div>
        </div>
        <div class="card-list__paginator-wrapper">
          <fc-paginator
            class="card-list__paginator"
            #paginator
            [pageSize]="pageSize"
            [totalCount]="page?.totalCount"
            [currentPageLength]="page?.items.length"
            [isLoading]="isPageChanging"
            (page)="onPageChange($event)"
          >
          </fc-paginator>
        </div>
      </ng-container>
      <ng-template #noGroups>
        <p class="card-list__not-found">
          <ng-container *ngIf="searchInput.value">
            {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINK.NOT_FOUND' | translate }}
          </ng-container>
          <ng-container *ngIf="!searchInput.value">
            {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINKED.NOT_FOUND' | translate }}
          </ng-container>
        </p>
      </ng-template>
    </div>
  </ng-template>
</form>
